export const getPathnameId = (pathname: string): string => {
    if (pathname.includes('profile')) return '3'
    if (pathname.includes('projects')) return '1'
    return '4'
}
